import React, { useState, useEffect } from 'react';
import { findIndex } from 'lodash';
import { produce } from 'immer';

import { Container, Row, Col } from '../../../grid';
import ContactCard from './card';
import ContactSearch from './search';
import { LoadingBlock } from '../loading/progress';
import Pagination from '../pagination';

import { IContact, useGetContacts } from '../../../libs/contact';

const PAGE_LIMIT = 9;

export interface MultiSelectContactsProps {
  selected: IContact[];
  updateSelected: (contacts: IContact[]) => any;
  isEnabled?: boolean;
}

const MultiSelectContacts: React.FC<MultiSelectContactsProps> = ({
  selected,
  updateSelected,
  isEnabled
}) => {
  const [page, setPage] = useState(1);
  const [keyword, setKeyword] = useState('');

  const { contacts, total, isLoading } = useGetContacts(
    {
      page: page - 1,
      keyword,
      limit: PAGE_LIMIT
    },
    isEnabled == null ? true : isEnabled
  );

  const selectedIds = selected ? selected.map((contact) => contact.id) : [];
  const numSelected = selected ? selected.length : 0;

  const toggleSelected = (contact: IContact) => {
    const updated = produce(selected, (draft) => {
      const cIndex = findIndex(draft, (entry) => entry.id === contact.id);
      if (cIndex !== -1) {
        draft.splice(cIndex, 1);
      } else {
        draft.push(contact);
      }
    });
    updateSelected(updated);
  };

  // Reset the page when keyword changed
  useEffect(() => {
    setPage(1);
  }, [keyword]);

  return (
    <>
      <h4>Selected Contacts ({numSelected})</h4>
      <Container fluid style={{ paddingLeft: 0, paddingRight: 0 }}>
        <Row>
          {selected &&
            selected.map((contact) => (
              <Col key={contact.id} md={8}>
                <ContactCard
                  contact={contact}
                  isSelected
                  onClick={() => toggleSelected(contact)}
                />
              </Col>
            ))}
        </Row>
      </Container>

      <h4>Choose Contacts</h4>

      {isLoading ? (
        <LoadingBlock />
      ) : (
        <Container fluid style={{ paddingLeft: 0, paddingRight: 0 }}>
          <Row className="mb-4">
            <Col>
              <ContactSearch
                keyword={keyword}
                setKeyword={setKeyword}
                noCreate
              />
            </Col>
          </Row>
          <Row className="mb-4">
            {contacts &&
              contacts.map((contact) => (
                <Col key={contact.id} md={8}>
                  <ContactCard
                    contact={contact}
                    isSelected={selectedIds.includes(contact.id)}
                    onClick={() => toggleSelected(contact)}
                  />
                </Col>
              ))}
          </Row>
          <Row>
            <Col>
              <Pagination
                total={total}
                limit={PAGE_LIMIT}
                onPageChange={setPage}
              />
            </Col>
          </Row>
        </Container>
      )}
    </>
  );
};

export default MultiSelectContacts;
